// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logsTabs ::ng-deep .mat-ink-bar {
  background-color: rgba(0, 0, 0, 0) !important;
}
.logsTabs ::ng-deep .mat-tab-label {
  height: 30px !important;
  opacity: unset !important;
  padding-inline: 1% !important;
}
.logsTabs ::ng-deep .mat-tab-label.mat-tab-label-active {
  padding: 6px;
  background-color: #12127c;
  color: white;
  font-weight: 700;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  height: 31px !important;
}
.logsTabs ::ng-deep .mat-tab-label {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: black;
  font-weight: 700;
}
.logsTabs ::ng-deep .mat-tab-body-content {
  transform: none;
  overflow: hidden;
}

::ng-deep.mattablog .mat-mdc-tab-label-container {
  background-color: #f4f4f4 !important;
}

.eventdatacss {
  max-height: 15vh;
  overflow-y: auto;
  display: inline-block;
}

.logdatacss {
  max-height: 15vh;
  overflow-y: auto;
  display: inline-block;
}

.logstatuscss {
  display: inline-block;
  font-size: 10px;
  padding: 4px;
  padding-inline: 8px;
  position: relative;
  left: 3%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 55%;
  margin: 0;
  top: 6%;
}

.eventselecttype {
  width: 100%;
  font-size: 11.5px;
  position: relative;
  height: 31px;
  background-color: #17a0b4;
  color: white !important;
  line-height: 1px;
  letter-spacing: normal;
  display: block !important;
}
.eventselecttype .mdc-button__label {
  left: 5px !important;
}

.eventselecttypeControl {
  width: 100%;
  border: none;
  padding-block: 2px;
  height: 31px;
}

.date_control_style {
  width: 100%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 2%;
}

.active_card {
  border-left: 4px solid #07a36e;
}

.failed_card {
  border-left: 4px solid #da606c;
}

.chevron_downStyle {
  position: absolute;
  right: -21px;
  top: 1px;
}

.log_reprocess {
  border: none;
  border-radius: 5px;
  box-shadow: 0 0px 3px, 0px 8px 0 rgba(0, 0, 0, 0.03);
  padding-block: 7px;
  padding-left: 7px;
  width: 100%;
}

.copy_icon {
  background-repeat: no-repeat;
  display: inline-block;
  fill: currentColor;
  height: 24px;
  width: 24px;
  font-size: 16px;
  position: relative;
  top: 8%;
  left: 2%;
  cursor: pointer;
}

.text-ellipsis {
  white-space: nowrap !important;
  width: 85% !important;
  text-overflow: ellipsis !important;
  overflow: hidden !important;
}

::ng-deep.messageiotEvent .modal-dialog {
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.messageiotLogs .modal-dialog {
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.messageiotEvent {
  top: 4% !important;
}

::ng-deep.messageiotLogs {
  top: 4% !important;
}

.close_icon {
  position: absolute;
  top: 27%;
  font-size: 16px;
  cursor: pointer;
  color: grey;
  font-weight: 600;
}

.btn_confirm {
  background-color: #ffffff !important;
  color: black !important;
  border: 1px solid;
  font-size: 12px !important;
  height: 28px !important;
  cursor: pointer;
}

.btn_confirm:focus {
  background-color: #17a2b8 !important;
  color: white !important;
  border: 1px solid;
}

::ng-deep.listbox .mat-checkbox-layout .mat-checkbox-inner-container {
  height: 15px !important;
  width: 15px !important;
}

::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox {
  width: 16px;
  height: 16px;
}
::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.msgreplist.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px !important;
  width: 16px !important;
}

::ng-deep.regxmllist.mat-mdc-checkbox .mdc-checkbox {
  width: 12px;
  height: 4px;
}
::ng-deep.regxmllist.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.regxmllist.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.regxmllist.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px !important;
  width: 16px !important;
}

::ng-deep.archivecbx .mdc-form-field {
  font-size: 12px !important;
}
::ng-deep.archivecbx .mdc-form-field .mdc-checkbox {
  bottom: 4px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/logs/logs.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAIE;EACE,6CAAA;AAHJ;AAME;EAEE,uBAAA;EACA,yBAAA;EACA,6BAAA;AALJ;AAQE;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,4BAAA;EACA,uBAAA;AANJ;AASE;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;AAPJ;AASE;EACE,eAAA;EAAgB,gBAAA;AANpB;;AASA;EACE,oCAAA;AANF;;AAQA;EACE,gBAAA;EACA,gBAAA;EACA,qBAAA;AALF;;AASA;EACE,gBAAA;EACA,gBAAA;EACA,qBAAA;AANF;;AASA;EACE,qBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,SAAA;EACA,OAAA;AANF;;AASA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AANF;AAOE;EACE,oBAAA;AALJ;;AAQA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AALJ;;AAOA;EACE,WAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,8BAAA;AAJF;;AAMA;EACE,8BAAA;AAHF;;AAMA;EACE,kBAAA;EACA,YAAA;EACA,QAAA;AAHF;;AAMA;EACE,YAAA;EACA,kBAAA;EACA,oDAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AAHF;;AAMA;EACE,4BAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;AAHF;;AAOA;EACE,8BAAA;EACE,qBAAA;EACA,kCAAA;EACA,2BAAA;AAJJ;;AAQA;EAEE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AANF;;AAQA;EAEE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AANF;;AAQA;EACE,kBAAA;AALF;;AAOA;EACE,kBAAA;AAJF;;AAQA;EACE,kBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AALF;;AASA;EACE,oCAAA;EACA,uBAAA;EACA,iBAAA;EACA,0BC7KS;ED+KT,uBC7KU;ED8KV,eAAA;AAPF;;AASA;EACE,oCAAA;EACA,uBAAA;EACA,iBAAA;AANF;;AAQA;EACE,uBAAA;EACA,sBAAA;AALF;;AASE;EACE,WAAA;EACA,YAAA;AANJ;AAOI;EACE,gCClMM;EDmMN,oCCnMM;AD8LZ;AAOI;EACE,YAAA;AALN;AAQE;EACE,uBAAA;EACA,sBAAA;AANJ;;AAUE;EACE,WAAA;EACA,WAAA;AAPJ;AAQI;EACE,gCCnNM;EDoNN,oCCpNM;AD8MZ;AAQI;EACE,YAAA;AANN;AASE;EACE,uBAAA;EACA,sBAAA;AAPJ;;AAWE;EACE,0BAAA;AARJ;AASI;EACE,sBAAA;AAPN","sourcesContent":["\r\n @import \"../../variables.scss\";\r\n\r\n.logsTabs{\r\n  ::ng-deep .mat-ink-bar {\r\n    background-color: rgba(0, 0, 0, 0) !important;\r\n  }\r\n\r\n  ::ng-deep .mat-tab-label {\r\n    // background-color: rgb(238, 180, 23) !important;\r\n    height: 30px  !important;\r\n    opacity:unset !important;\r\n    padding-inline: 1% !important;\r\n  }\r\n\r\n  ::ng-deep .mat-tab-label.mat-tab-label-active {\r\n    padding: 6px;\r\n    background-color: #12127c;\r\n    color: white;\r\n    font-weight: 700;\r\n    border-top-left-radius: 5px;\r\n    border-top-right-radius: 5px;\r\n    height: 31px !important;\r\n\r\n  }\r\n  ::ng-deep .mat-tab-label {\r\n    min-width: 25px !important;\r\n    padding: 5px;\r\n    background-color: transparent;\r\n    color: black;\r\n    font-weight: 700;\r\n  }\r\n  ::ng-deep .mat-tab-body-content{\r\n    transform: none;overflow: hidden;\r\n  }\r\n}\r\n::ng-deep.mattablog .mat-mdc-tab-label-container {\r\n  background-color: #f4f4f4 !important;\r\n}\r\n.eventdatacss{\r\n  max-height: 15vh;\r\n  overflow-y: auto;\r\n  display: inline-block;\r\n}\r\n\r\n\r\n.logdatacss{\r\n  max-height: 15vh;\r\n  overflow-y: auto;\r\n  display: inline-block;\r\n}\r\n\r\n.logstatuscss{\r\n  display: inline-block;\r\n  font-size: 10px;\r\n  padding: 4px;\r\n  padding-inline: 8px;\r\n  position: relative;\r\n  left: 3%;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 55%;\r\n  margin: 0;\r\n  top: 6%;\r\n}\r\n\r\n.eventselecttype{\r\n  width: 100%;\r\n  font-size: 11.5px;\r\n  position: relative;\r\n  height: 31px;\r\n  background-color: #17a0b4;\r\n  color: white  !important;\r\n  line-height: 1px;\r\n  letter-spacing: normal;\r\n  display: block !important;\r\n  .mdc-button__label{\r\n    left: 5px  !important;\r\n  }\r\n}\r\n.eventselecttypeControl{\r\n    width: 100%;\r\n    border: none;\r\n    padding-block: 2px;\r\n    height: 31px;\r\n}\r\n.date_control_style {\r\n  width: 100%;\r\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 2%;\r\n}\r\n\r\n.active_card {\r\n  border-left: 4px solid #07a36e;\r\n}\r\n.failed_card {\r\n  border-left: 4px solid #da606c;\r\n}\r\n\r\n.chevron_downStyle{\r\n  position: absolute;\r\n  right: -21px;\r\n  top: 1px;\r\n}\r\n\r\n.log_reprocess{\r\n  border: none;\r\n  border-radius: 5px;\r\n  box-shadow: 0 0px 3px, 0px 8px 0 rgb(0 0 0 / 3%);\r\n  padding-block: 7px;\r\n  padding-left: 7px;\r\n  width: 100%;\r\n}\r\n\r\n.copy_icon{\r\n  background-repeat: no-repeat;\r\n  display: inline-block;\r\n  fill: currentColor;\r\n  height: 24px;\r\n  width: 24px;\r\n  font-size: 16px;\r\n  position: relative;\r\n  top: 8%;\r\n  left: 2%;\r\n  cursor: pointer;\r\n}\r\n\r\n\r\n.text-ellipsis{\r\n  white-space: nowrap !important;\r\n    width: 85% !important;\r\n    text-overflow: ellipsis !important;\r\n    overflow: hidden !important;\r\n}\r\n\r\n\r\n::ng-deep.messageiotEvent .modal-dialog {\r\n  // max-width: 97%!important;\r\n  max-height: 60%!important;\r\n  height: 60%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.messageiotLogs .modal-dialog {\r\n  // max-width: 97%!important;\r\n  max-height: 60%!important;\r\n  height: 60%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.messageiotEvent{\r\n  top: 4%!important;\r\n}\r\n::ng-deep.messageiotLogs{\r\n  top: 4%!important;\r\n}\r\n\r\n\r\n.close_icon{\r\n  position: absolute;\r\n  top: 27%;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  color: grey;\r\n  font-weight: 600;\r\n}\r\n\r\n\r\n.btn_confirm{\r\n  background-color: #ffffff !important;\r\n  color: black !important;\r\n  border: 1px solid;\r\n  font-size: $fontsize;\r\n  // color: $btntextcolor;\r\n  height: $btnHeight;\r\n  cursor: pointer;\r\n}\r\n.btn_confirm:focus{\r\n  background-color: #17a2b8 !important;\r\n  color: white !important;\r\n  border: 1px solid;\r\n}\r\n::ng-deep.listbox .mat-checkbox-layout .mat-checkbox-inner-container{\r\n  height: 15px  !important;\r\n  width: 15px !important;\r\n}\r\n\r\n::ng-deep.msgreplist.mat-mdc-checkbox {\r\n  .mdc-checkbox {\r\n    width: 16px;\r\n    height: 16px;\r\n    .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n      border-color: $btn-color;\r\n      background-color: $btn-color;\r\n    }\r\n    .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n      color: white;\r\n  }\r\n  }\r\n  .mdc-checkbox__background{\r\n    height: 16px !important;\r\n    width: 16px !important;\r\n  }\r\n}\r\n::ng-deep.regxmllist.mat-mdc-checkbox {\r\n  .mdc-checkbox {\r\n    width: 12px;\r\n    height: 4px;\r\n    .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n      border-color: $btn-color;\r\n      background-color: $btn-color;\r\n    }\r\n    .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n      color: white;\r\n  }\r\n  }\r\n  .mdc-checkbox__background{\r\n    height: 16px !important;\r\n    width: 16px !important;\r\n  }\r\n}\r\n::ng-deep.archivecbx{\r\n  .mdc-form-field{\r\n    font-size: 12px !important;\r\n    .mdc-checkbox{\r\n      bottom: 4px !important;\r\n    }\r\n  }\r\n}","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
